export const SITE_DISPLAY_NAME = 'Genesis Outdoor Living';
export const SITE_DOMAIN = 'genesisoutdoorlivingnc.com';
